const LOG_LEVELS = ["DEBUG", "INFO", "WARN", "ERROR"];
const LOG_LEVEL = LOG_LEVELS.includes(process.env.REACT_MICROSPEC_LOG_LEVEL) ?
    process.env.REACT_MICROSPEC_LOG_LEVEL :
    "INFO";

export const debugLog = (message, ...optionalParams) => {
    if (["DEBUG"].includes(LOG_LEVEL)) {
        console.debug(`[DEBUG] ${message}`, ...optionalParams);
    }
}

export const infoLog = (message, ...optionalParams) => {
    if (["DEBUG", "INFO"].includes(LOG_LEVEL)) {
        console.info(`[INFO] ${message}`, ...optionalParams);
    }
}

export const warnLog = (message, ...optionalParams) => {
    if (["DEBUG", "INFO", "WARN"].includes(LOG_LEVEL)) {
        console.warn(`[WARN] ${message}`, ...optionalParams);
    }
}

export const errorLog = (message, ...optionalParams) => {
    if (["DEBUG", "INFO", "WARN", "ERROR"].includes(LOG_LEVEL)) {
        console.error(`[ERROR] ${message}`, ...optionalParams);
    }
}